import { ip_back } from "../config";

function authHeaders() {
  const token =
    (typeof window !== "undefined" && localStorage.getItem("token")) || "";
  return token
    ? { Authorization: token, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
}

export async function fetchProposedObjectiveMetrics(exId, {
  playerUserId,
  goalRole = "primary",
  signal,
} = {}) {
  if (!exId || !playerUserId) return null;
  const q = new URLSearchParams({
    player_user_id: String(playerUserId),
    goal_role: String(goalRole || "primary"),
  });
  const resp = await fetch(
    `${ip_back}api/exercises/${encodeURIComponent(exId)}/proposed-objective-metrics?${q}`,
    { method: "GET", headers: authHeaders(), signal }
  );
  const json = await resp.json().catch(() => ({}));
  if (!resp.ok || !json?.status) return null;
  return json.data || null;
}

export async function fetchPlayerExerciseObjectiveMetrics(userId, exId, {
  goalRole = "primary",
  signal,
} = {}) {
  if (!userId || !exId) return null;
  const q = new URLSearchParams({ goal_role: String(goalRole || "primary") });
  const resp = await fetch(
    `${ip_back}api/user/${encodeURIComponent(userId)}/exercises/${encodeURIComponent(exId)}/objective-metrics?${q}`,
    { method: "GET", headers: authHeaders(), signal }
  );
  const json = await resp.json().catch(() => ({}));
  if (!resp.ok || !json?.status) return null;
  return json.data || null;
}

export async function savePlayerExerciseObjectiveMetrics(userId, exId, {
  goalRole = "primary",
  metricKinds = [],
  source = "coach_picked",
  signal,
} = {}) {
  if (!userId || !exId) throw new Error("userId and exId required");
  const resp = await fetch(
    `${ip_back}api/user/${encodeURIComponent(userId)}/exercises/${encodeURIComponent(exId)}/objective-metrics`,
    {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify({
        goal_role: goalRole,
        metric_kinds: metricKinds,
        source,
      }),
      signal,
    }
  );
  const json = await resp.json().catch(() => ({}));
  if (!resp.ok || !json?.status) {
    throw new Error(json?.message || "Failed to save objective metrics");
  }
  return json.data || null;
}
